import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { meta as stackMeta } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/StackBlock/StackBlockMetaData";

export const meta: ComponentMeta = {
  ...stackMeta,
};
